import React from 'react';

// Map a chain/network label — in any of the forms the app stores it (TRC20/TRON,
// ERC20/ETH, BEP20/BSC, BTC…) — to that chain's block-explorer TRANSACTION URL.
// The explorer is decided by the CHAIN, not the token: USDT-on-TRON → Tronscan,
// USDT-on-Ethereum → Etherscan. Returns null when there's no hash or no known
// explorer for the chain (e.g. an internal / off-chain ledger move).
export function explorerTxUrl(hash, chain) {
  if (!hash) return null;
  const c = String(chain || '').toUpperCase();
  if (['TRC20', 'TRON', 'TRX'].includes(c)) return `https://tronscan.org/#/transaction/${hash}`;
  if (['ERC20', 'ETH', 'ETHEREUM'].includes(c)) return `https://etherscan.io/tx/${hash}`;
  if (['BEP20', 'BSC', 'BNB', 'BINANCE'].includes(c)) return `https://bscscan.com/tx/${hash}`;
  if (['BTC', 'BITCOIN'].includes(c)) return `https://www.blockchain.com/explorer/transactions/btc/${hash}`;
  return null;
}

// Render a crypto transaction hash as a clickable link to its block explorer.
// Falls back to plain (optionally truncated) text when there is no hash or no
// known explorer for the chain, so it's safe to drop in anywhere a TXID shows.
//   <TxHashLink hash={tx.tx_hash} chain={tx.chain} />
//   <TxHashLink hash={h} chain={c} truncate={8} />   → "1234abcd…ef567890"
// onClick stops propagation so clicking the link never triggers a surrounding
// clickable row/card.
export default function TxHashLink({ hash, chain, truncate = 0, className, style, children }) {
  if (!hash) return children || null;
  const url = explorerTxUrl(hash, chain);
  const text = children || (truncate > 0 && hash.length > truncate * 2 + 1
    ? `${hash.slice(0, truncate)}…${hash.slice(-truncate)}`
    : hash);
  if (!url) {
    return <span className={className} style={style} title={hash}>{text}</span>;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={{ color: '#0969da', textDecoration: 'underline', wordBreak: 'break-all', ...style }}
      title={`View on block explorer: ${hash}`}
      onClick={(e) => e.stopPropagation()}
    >
      {text}
    </a>
  );
}
